import { getWebInstrumentations, initializeFaro, Faro } from '@grafana/faro-web-sdk';

export const initializeInstrumentation = (): Faro => {
  const faro = initializeFaro({
    url: 'https://faro-collector-prod-eu-west-3.grafana.net/collect/91ebc06d2d06cbe28e09878bf364b84a',
    app: {
      name: 'edtech-documentation-tool-app',
      version: '1.2.3',
      environment: 'production',
    },
    instrumentations: [...getWebInstrumentations()],
  });

  faro.api.pushLog(['Telemetry is ready']);
  return faro;
};
